/**
* Used to show "Made with Mailchimp" at the bottom of signup forms.
* This was formerly known as monkey rewards.
**/
define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dijit/_WidgetBase", "dijit/_TemplatedMixin", "dojo/text!./templates/textBadge.html", "dojo-proxy-loader?name=dojo/dom-attr!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module"], function (declare, _WidgetBase, _TemplatedMixin, template, domAttr) {
  return declare([_WidgetBase, _TemplatedMixin], {
    templateString: template,
    rewardsUrl: "mailchimp.com",
    postCreate: function () {
      this.inherited(arguments);
      //update the url with what is passed in
      domAttr.set(this.monkeyRewardsLink, "href", this.rewardsUrl);
    }
  });
});